var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 24,
    rx: 4,
    fill: "#91D0AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39061 4.59172C8.63141 4.46025 8.92479 4.47076 9.15557 4.61912L19.6556 11.3691C19.8702 11.5071 20 11.7448 20 12C20 12.2552 19.8702 12.4929 19.6556 12.6309L9.15557 19.3809C8.92479 19.5292 8.63141 19.5398 8.39061 19.4083C8.1498 19.2768 8 19.0244 8 18.75V5.25C8 4.97565 8.1498 4.72318 8.39061 4.59172ZM9.5 6.62375V17.3763L17.8631 12L9.5 6.62375Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/start.dcfc853cdb679400511bd38020c96c04.svg";